import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

function useDebounced(value, ms = 450) {
  const [v, setV] = useState(value);
  useEffect(() => { const t = setTimeout(() => setV(value), ms); return () => clearTimeout(t); }, [value, ms]);
  return v;
}

/** Live calculation + saved-profile state shared by the loan calculators. */
export function useLoanTool(kind, defaults, extraBody = {}) {
  const [inputs, setInputs] = useState(defaults);
  const [pid, setPid] = useState(null);
  const [proposed, setProposed] = useState(0);
  const profile = useQuery({
    queryKey: ["fin-profile", pid],
    queryFn: async () => (await api.get(`/finance/profiles/${pid}`)).data,
    enabled: !!pid,
  });
  const txns = profile.data?.transactions || [];
  const raw = JSON.stringify({ inputs, extras: txns.map((t) => ({ date: t.date, amount: t.amount, counts_toward_allowance: t.counts_toward_allowance })), proposed_prepayment: proposed || null, ...extraBody });
  const body = JSON.parse(useDebounced(raw));
  const calc = useQuery({
    queryKey: ["fin-calc", kind, body],
    queryFn: async () => (await api.post(`/finance/calc/${kind}`, body)).data,
    retry: false, placeholderData: (prev) => prev,
  });
  const set = (k) => (v) => setInputs((s) => ({ ...s, [k]: v }));
  const select = (id, inp) => { setPid(id); if (inp) setInputs({ ...defaults, ...inp }); };
  return { inputs, setInputs, set, pid, select, calc, txns, setProposed, reset: () => setInputs(defaults) };
}
